import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'
import { db, functions } from '@/store/firebase'
import firestoreUtils from '@/utils/firestore'
import filter from '../assets/filterModel'
import filterCustomer from '../assets/filterCustomerModel'
import _ from 'lodash'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    userData: null,
    loading: false,
    filterModel: null,
    filtersState: [],
    count: 0,
    scheduleCount: 0,
    companyData: null,
    boardItems: [
      { text: 'Arquivo', value: 'arquivo' },
      { text: 'Prospecção', value: 'leads' },
      { text: 'Apresentação', value: 'apresentacao' },
      { text: 'Negociação', value: 'negociacao' },
      { text: 'Fechamento', value: 'fechamento' }
    ],
    boardCustomers: {
      arquivo: [],
      leads: [],
      apresentacao: [],
      negociacao: [],
      fechamento: []
    },
    statuses: [],
    campaigns: [],
    attendents: [],
    users: [],
    customersInfos: [],
    contractStatuses: []
  },

  getters: {
    isAdmin: state => {
      if (state.user && state.user.profile) {
        return state.user.profile === 'administrator'
      } else return false
    },
    profile: state => {
      if (state.user && state.user.profile) {
        return state.user.profile
      } else return ''
    },
    company: state => {
      if (state.user && state.user.companyId) {
        return state.user.companyId
      } else return ''
    },
    companyData: state => state.companyData,
    userData: state => state.userData,
    branch: state => {
      if (state.user && state.user.branchId) {
        return state.user.branchId
      } else return ''
    },
    loading: state => {
      return state.loading
    },
    user: state => {
      return state.user
    },
    customersInfo: state => {
      return state.customersInfo
    },
    count: state => {
      return state.count
    },
    filterState: state => {
      return state.filtersState
    },
    scheduleCount: state => state.scheduleCount
  },

  actions: {

    loadUsers({ commit, state }) {
      const company = state.user.companyId
      const branch = state.user.branchId

      let col = db.collection('users').orderBy('name')

      if (state.user.profile === 'attendant') {
        col = col.doc(state.user.uid)
      } else if (state.user.profile === 'manager') {
        col = col.where('company.id', '==', company)
      } else if (state.user.profile === 'supervisor') {
        col = col.where('branch.id', '==', branch)
      }

      let users = []
      col.get()
        .then(payload => {
          if (!payload.empty) {
            if (payload.docs) {
              users = payload.docs.map(item =>
                firestoreUtils.docToObject(item)
              )
            } else {
              users = [firestoreUtils.docToObject(payload)]
            }
          }
          commit('updateUsers', users)
        })
        .catch(err => {
          console.error('loadUsers', err)
        })
    },

    loadCustomersInfos({ commit, state }) {
      let customersInfoQuery = db.collection('customersInfo').orderBy('blacklistInfo.date', 'desc').limit(50)

      let customersInfos = []
      return customersInfoQuery.get()
        .then(querySnapshot => {
          if (!querySnapshot.empty) {
            customersInfos = querySnapshot.docs.map(item => firestoreUtils.docToObject(item))
          } else {
            customersInfos = []
          }
          commit('updateCustomersInfos', customersInfos)
          return customersInfos
        })
        .catch(err => {
          console.error('loadCustomersInfos', err)
        })
    },

    loadCampaigns({ commit, state }) {
      const company = state.user.companyId
      // const branch = state.user.branchId
      const profile = state.user.profile

      if (profile === 'attendant') {
        let items
        const uid = state.user.uid

        return db.collection('distributions')
          .where('company.id', '==', company)
          .where('usersTree', 'array-contains', `user-${uid}`).get()
          .then(payload => {
            items = payload.docs.map(item =>
              firestoreUtils.docToObject(item)
            )
            let campaigns = items.map(item => {
              return {
                iuid: item.campaign.id,
                name: item.campaign.name
              }
            })
            return commit('updateCampaigns', campaigns.sort((a, b) => a.name > b.name ? 1 : -1))
          })
      }

      let col = db.collection('campaigns')
        .orderBy('name')

      if (profile === 'manager') {
        col = col.where('company.id', '==', company)
      } else if (profile === 'supervisor') {
        // TODO: Ajustar para buscar somente as campanhas da branch
        col = col.where('company.id', '==', company)
      }

      let campaigns = []
      col.get()
        .then(payload => {
          if (!payload.empty) {
            campaigns = payload.docs.map(item =>
              firestoreUtils.docToObject(item)
            )
          }
          return commit('updateCampaigns', campaigns)
        })
        .catch(err => {
          console.error('loadUsers', err)
        })
    },

    loadStatuses({ commit, state }) {
      const company = state.user.companyId
      let statuses = []
      db.collection('status')
        .where('company.id', '==', company)
        .get()
        .then(data => {
          if (!data.empty) {
            statuses = data.docs.map(item =>
              firestoreUtils.docToObject(item)
            )
          }
          statuses = [
            { iuid: 'NOVO', name: 'Novo' },
            { iuid: 'CAMPANHA', name: 'Campanha' }
          ].concat(statuses.sort((a, b) => a.name > b.name ? 1 : -1))
          commit('updateStatuses', statuses)
        })
    },

    loadBoardCustomers({ commit, state }, payload) {
      let col = db.collection('customers').orderBy('order')

      const company = state.user.companyId
      const branch = state.user.branchId

      if (state.user.profile === 'attendant') {
        col = col.where('attendant.id', '==', state.user.uid)
      } else if (state.user.profile === 'manager') {
        col = col.where('company.id', '==', company)
      } else if (state.user.profile === 'supervisor') {
        col = col.where('branch.id', '==', branch)
      }

      if (payload) {
        const filters = payload.filters
        if (filters) {
          if (filters.search && filters.search.length > 0) col = col.where('keywords', 'array-contains', filters.search.toUpperCase())
          if (filters.statuses && filters.statuses.length) col = col.where('status.id', 'in', filters.statuses)
          if (filters.campaigns) col = col.where('campaign.id', '==', filters.campaigns)
          if (filters.users) col = col.where('attendant.id', '==', filters.users)
        }
      }

      const boardKeys = payload.boards
      for (const key of boardKeys) {
        col.where('board', '==', key)
          .limit(200)
          .get()
          .then(payload => {
            let customers = []
            if (!payload.empty) {
              customers = payload.docs.map(item =>
                firestoreUtils.docToObject(item)
              )
            }
            commit('updateBoardCustomers', { board: key, customers })
          })
      }
    },

    updateCustomer({ commit, state }, payload) {
      const data = payload.data
      const customer = payload.customer
      const history = []
      if (data.board) history.push(`Movido para o painel ${data.board}.`)
      if (data.rating) history.push(`Qualificado como ${data.rating} estrelas.`)
      if (data.contractStatus) history.push(`Alterado o status da contrato para ${data.contractStatus}.`)
      if (data.contractValue) history.push(`Alterado o valor da proposta para ${data.contractValue}.`)
      if (data.contractValuePaid) history.push(`Alterado o valor do contrato pago para ${data.contractValuePaid}.`)

      const call = {
        createdAt: Date.now(),
        user: {
          id: state.userData.iuid,
          name: state.userData.name || null
        },
        customer: {
          id: customer.iuid,
          name: customer.nome || null,
          cpf: customer.cpf || null
        },
        company: customer.company || null,
        branch: customer.branch || null,
        campaign: customer.campaign || null,
        description: history.join('; '),
        contractValue: data.contractValue || 0,
        contractValuePaid: data.contractValuePaid || 0,
        contractStatus: data.contractStatus || null
      }

      db.collection('calls')
        .add(call)
      return db.collection('customers').doc(customer.iuid)
        .set(data, { merge: true })
        .then(result => {
          _.merge(customer, data)
        })
    },

    loadCompanyData({ commit, state }) {
      if (!state.user.companyId) return null
      return db.collection('companies').doc(state.user.companyId).get()
        .then(doc => {
          if (!doc.exists) return null
          const data = doc.data()
          commit('setCompanyData', data)
          return data
        })
    },

    findUsersCount({ commit, state }) {
      if (!state.user.companyId) return 0
      return db.collection('users').where('company.id', '==', state.user.companyId).get()
        .then(result => {
          const users = result.docs.map(item =>
            firestoreUtils.docToObject(item)
          )
          return users.filter((user) => user.disabled !== true).length
        })
    },

    agreeTerms({ commit, state }, payload) {
      const companyId = state.user.companyId
      const terms = {
        terms: {
          ...payload,
          date: new Date(),
          userId: state.user.uid,
          userEmail: state.user.email,
          agreed: true
        }
      }
      return db.collection('companies').doc(companyId)
        .update(terms)
        .then(value => {
          commit('agreeTerms', payload)
        })
        .catch(err => {
          console.error(err)
        })
    },

    agreeUserTerms({ commit, state }, payload) {
      const terms = {
        terms: {
          ...payload,
          date: new Date(),
          userId: state.user.uid,
          userEmail: state.user.email,
          agreed: true
        }
      }
      return db.collection('users').doc(state.user.uid)
        .update(terms)
        .then(value => {
          commit('agreeTerms', payload)
        })
        .catch(err => {
          console.error(err)
        })
    },

    agreeContract({ commit, state }, payload) {
      const companyId = state.user.companyId
      const contract = {
        contract: {
          ...payload,
          date: new Date(),
          userId: state.user.uid,
          userEmail: state.user.email,
          agreed: true
        },
        terms: {
          userName: payload.userName,
          date: new Date(),
          userId: state.user.uid,
          userEmail: state.user.email,
          agreed: true
        }
      }
      return db.collection('companies').doc(companyId)
        .update(contract)
        .then(value => {
          commit('agreeContract', payload)
        })
        .catch(err => {
          console.error(err)
        })
    },

    disagreeContract({ commit, state }, payload) {
      const company = state.user.companyId
      const contract = {
        plan: 'disagree',
        date: new Date(),
        userId: state.user.uid,
        agreed: false,
        feeValue: 0
      }
      return db.collection('companies').doc(company)
        .update({ disabled: true, contract })
        .then(value => {
          commit('disagreeContract', payload)
        })
        .catch(err => {
          console.error(err)
        })
    },

    setUser({ commit, state }, payload) {
      db.collection('users').doc(payload.uid).get()
        .then(doc => {
          if (!doc.exists) return commit('setUserData', null)
          const user = firestoreUtils.docToObject(doc)
          commit('setUserData', user)
        })
      commit('setUser', payload)
    },

    setLoading({ commit, state }, payload) {
      commit('setLoading', payload)
    },

    setCount({ commit, state }, payload) {
      commit('setCount', payload)
    },

    setFilter({ commit, state }, payload) {
      commit('setFilter', payload)
    },

    addFilter({ commit, state }, payload) {
      commit('addFilter', payload)
    },

    getFilter({ commit, state }, payload) {
      let model = payload
      let filters = []
      model.forEach(item => {
        item.filters = [...filter.filters]
        item.textOperators = [...filter.textOperators]
        item.dateOperators = [...filter.dateOperators]
        filters.push(item)
      })
      commit('getFilter', payload)
    },

    removeFilter({ commit, state }, payload) {
      commit('removeFilter', payload)
    },

    submitCampaign: async function({ commit, state, getters, dispatch }, { modelCampaign, filter }) {
      let doc
      let company = getters.company
      let user = getters.user
      let model = {
        acceptedTerms: {
          userId: user.uid,
          email: modelCampaign.acceptedTerms.email,
          date: modelCampaign.acceptedTerms.date
        },
        iuid: modelCampaign.iuid,
        name: modelCampaign.name,
        filters: filter,
        user: {
          id: user.uid,
          email: user.email
        },
        records: state.count,
        total: state.count,
        order: modelCampaign.order,
        direction: modelCampaign.direction,
        showHistory: modelCampaign.showHistory || false,
        allowsDuplicateCustomers: modelCampaign.allowsDuplicateCustomers || false
      }

      const iuid = model.iuid
      delete model.iuid

      if (company) {
        const doc = await db
          .collection('companies')
          .doc(company)
          .get()

        if (doc) {
          const companyDoc = firestoreUtils.docToObject(doc)
          model.company = {
            id: companyDoc.iuid,
            name: companyDoc.name,
            cnpj: companyDoc.cnpj
          }
        }
      }

      if (iuid) {
        doc = db
          .collection('campaigns')
          .doc(iuid)
          .update(model)
      } else {
        model.createdAt = new Date()
        doc = db.collection('campaigns').add(model)
      }

      doc
        .then(data => {
          router.push('/campaigns')
          this._vm.$snotify.success('Salvo com sucesso!')
          commit('setLoading', false)
          commit('setCount', 0)
        })
        .catch(err => {
          commit('setLoading', false)
          console.log(err)
          this._vm.$snotify.error('Ops! Ocorreu um erro')
        })
    },

    setFilterState({ state, commit }, payload) {
      commit('setFilterState', payload)
    },

    async onCampaignCreated({ state, commit }, payload) {
      return functions
        .httpsCallable('createCustomersAndAssignAttendant')({ campaignId: payload })
        .then(result => result)
        .catch(err => alert(err.message))
    },

    clearFilters({ state, commit }, payload) {
      commit('clearFilters')
    },

    updateScheduleCount({ state, commit }, payload) {
      commit('updateScheduleCount', payload)
    }

  },

  mutations: {

    updateUsers(state, payload) {
      state.users = payload
    },

    updateCustomersInfos(state, payload) {
      state.customersInfos = payload
    },

    updateCampaigns(state, payload) {
      state.campaigns = payload
    },

    updateStatuses(state, payload) {
      state.statuses = payload
    },

    updateBoardCustomers(state, payload) {
      state.boardCustomers[payload.board] = payload.customers
    },

    agreeTerms(state, payload) {
      console.log('agreeTerms mutations')
    },

    agreeContract(state, payload) {
      console.log('agreeContract mutations')
    },

    disagreeContract(state, payload) {
      console.log('disagreeContract mutations')
    },

    setUser(state, payload) {
      state.user = payload
    },

    setUserData(state, payload) {
      state.userData = payload
    },

    setCompanyData(state, payload) {
      state.companyData = payload
    },

    setLoading(state, payload) {
      state.loading = payload
    },

    setCount(state, payload) {
      state.count = payload
    },

    setFilter(state, payload) {
      state.filterModel = payload
    },

    getFilter(state, payload) {
      state.filtersState = payload
    },

    addFilter(state, payload) {
      if (payload && payload.isCustomer) {
        state.filtersState.unshift(_.cloneDeep(filterCustomer))
      } else {
        state.filtersState.unshift(_.cloneDeep(filter))
      }
    },

    clearFilters(state) {
      state.filtersState = []
      state.count = 0
    },

    removeFilter(state, payload) {
      if (payload === 0) {
        state.filtersState[0].value = ''
        state.filtersState[0].field = ''
        state.filtersState[0].operator = ''
      } else {
        state.filtersState.splice(payload, 1)
      }
    },

    setFilterState(state, payload) {
      state.filtersState[payload.index].items = payload.data
    },

    updateScheduleCount(state, payload) {
      if (!state.user || state.user.profile === 'administrator') return

      let col = db.collection('customers')
        .where('status.scheduleDate', '<=', new Date())
        .orderBy('status.scheduleDate')

      const company = state.user.companyId
      const branch = state.user.branchId

      if (state.user.profile === 'attendant') {
        col = col.where('attendant.id', '==', state.user.uid)
      } else if (state.user.profile === 'manager') {
        col = col.where('company.id', '==', company)
      } else if (state.user.profile === 'supervisor') {
        col = col.where('branch.id', '==', branch)
      }

      col.get().then(queryResult => {
        if (queryResult.empty) {
          state.scheduleCount = 0
        } else {
          state.scheduleCount = queryResult.size
        }
      })
    }
  }
})
